import { Box } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Bubble from "../Bubble";

const PageNav = ({ handleBubbleNav, totBubble, currBubble, setCurrBubble }) => {
  const coinNavStyle = {
    width: "100%",
    height: "15%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
  const leftArrowStyle = {
    color: "#2E117F",
    opacity: currBubble === 0 ? "50%" : "100%",
    mr: "0.25rem",
  };
  const rightArrowStyle = {
    color: "#2E117F",
    opacity: currBubble === totBubble - 1 ? "50%" : "100%",
    ml: "0.25rem",
  };

  return (
    <Box sx={coinNavStyle}>
      <KeyboardArrowLeftIcon
        sx={leftArrowStyle}
        onClick={() => handleBubbleNav("left")}
      />
      {Array.from({ length: totBubble }, (_, index) => (
        <Bubble
          key={index}
          radius="0.5rem"
          currBubble={currBubble}
          setCurrBubble={setCurrBubble}
          i={index}
        />
      ))}
      <KeyboardArrowRightIcon
        sx={rightArrowStyle}
        onClick={() => handleBubbleNav("right")}
      />
    </Box>
  );
};

export default PageNav;
